import { fromJS } from 'immutable';

import { TypedMap } from 'utils/typed-map';
import LocationObject from 'entities/locationObject/model';

import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  REQUEST_ADDRESS_CHANGE,
  CLEAR_ADDRESS_CHANGE,
} from './constants';

export type OrganizationPageState = TypedMap<{
  loading: boolean;
  error?: Error;
  newAddress?: LocationObject;
}>;

export const initialState: OrganizationPageState = fromJS({
  loading: false,
  error: undefined,
  newAddress: undefined,
});

export default (
  state = initialState,
  action: {
    type: string;
    error?: Error;
    newAddress?: LocationObject;
  }
): OrganizationPageState => {
  switch (action.type) {
    case INIT:
      return state.set('loading', true);

    case INIT_SUCCESS:
      return state.set('loading', false);

    case INIT_FAILED:
      return state.merge({ loading: false, error: action.error });

    case REQUEST_ADDRESS_CHANGE:
      return state.set('newAddress', action.newAddress);

    case CLEAR_ADDRESS_CHANGE:
      return state.set('newAddress', undefined);

    default:
      return state;
  }
};
